import React from "react"
import {NestedRoute} from "@irati/utils/history/routing"
import {match as Match} from "react-router-dom"
import History, {historyContext} from "@irati/utils/history"
import {Query} from "@irati/utils/services/apollo"
import {feedPollQuery} from "@irati/recognition/apollo/query/FeedPoll"
import {ErrorPopup} from "@irati-web/reward/src/components/Success"
import PollPopup from "../../../components/Popup/Poll"
import {RecognitionRoutes} from "../../../enums/Routes"
import PublishPollModal from "../../../components/Popup/Poll/PublishPollConfirmation"
import ClosedPollsList from "./ClosedPolls"

interface Props {
  match: Match
}
const PollView = (props: Props, context) => {
  const {match} = props
  const {uuid: pollId} = match.params as {uuid: string}
  const handleAfterExitModal = () => {
    History.push(RecognitionRoutes.MY_ACCOUNT_CLOSED_POLLS, context, {
      scrollToTop: false
    })
  }
  if (!pollId) {
    return
  }
  return (
    <Query query={feedPollQuery.query} variables={{id: pollId}} Error={ErrorPopup}>
      {({data: {poll}}) => {
        return (
          <>
            <NestedRoute
              useGrid={false}
              match="/recognition/account/my-closed-polls"
              path="/:uuid"
              exact
              title="Closed Poll Details"
              component={() => <PollPopup poll={poll} onAfterExitModal={handleAfterExitModal} />}
            />
            <NestedRoute
              useGrid={false}
              match="/recognition/account/my-closed-polls"
              path="/:uuid/publish"
              title="Publish Closed Poll"
              component={(routeProps) => <PublishPollModal poll={poll} {...routeProps} />}
            />
          </>
        )
      }}
    </Query>
  )
}
PollView.contextTypes = historyContext
const ClosedPolls = () => {
  return (
    <>
      <ClosedPollsList />
      <NestedRoute useGrid={false} match="/recognition/account/my-closed-polls" path="/:uuid" title="Closed Poll" component={PollView} />
    </>
  )
}

export default ClosedPolls
